import { Component, Fragment } from 'react';
import mandateStyles from '../../styles/mandate.scss';
import {
  MANDATE_ENUM,
  MANDATE_TYPE_URL_MAP,
  ERROR_MESSAGES,
  MONTH_TEXT_MAP,
  PAYMENT_PROVIDER,
} from '../../constants';

import {
  BANK_LIST,
  MAP_BANK_TO_PAYMENT,
  MAP_INVESTMENTTYPE_TO_ORDERITEMTYPE,
} from '../../constants/mandate';
import { Router } from '../../configs/routes';
import dotProp from 'es5-dot-prop';
import { addScriptDynamically, showError, getNextMonthDate } from '../../utils';
import Modal from '../../components/modal';
import Nach from '../../components/mandate/nach';
import { trackAction } from '../../utils/trackActions';
import cx from 'classnames';
import { Api } from '../../api';
import { getAmountSelectData } from '../../utils/commonUtils';
import MandateSuccessScheduleModal from '../mandate/mandateSuccessScheduleModal';
import styles from '../../styles/paymentSchedule/schedulePayment.scss';
import { stringify } from 'query-string';
import DateSelector from '../ui/dateSelector';
import PaymentLinkScheduleModal from '../mandate/PaymentLinkScheduleModal';
import { getUserInfoSessionData } from '../../utils/sessionUtil';

const api = new Api();

interface Props {
  dismiss: () => void;
  investmentType?: string;
  amount?: number;
  url?: any;
}

interface State {
  filename: string;
  currentSelectedMandateFormat: MANDATE_ENUM;
  uploadingFile: boolean;
  imageData: File;
  mandateAmount: number;
  selectedMethod: string;
  authorizing: boolean;
  userBankDetails?: any;
  downloadingForm: boolean;
  fileType: string;
  selectedBank: string;
  userBankCode: string;
  mandateInfo: any;
  showMandateSuccessModal: boolean;
  isMandateSelected: boolean;
  todayDate: string;
  nextMonthDate: string;
  firstPaymentDate: string;
  sipDate: string;
  isSipDateSelected: boolean;
  isDateFilled: boolean;
  selectedPaymentMethod: string;
}

const { EMANDATE, PAPER_NACH } = MANDATE_ENUM;
const date = new Date();

class ScheduleMandate extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filename: '',
      uploadingFile: false,
      currentSelectedMandateFormat: null,
      mandateAmount: 2000,
      imageData: null,
      selectedMethod: '',
      authorizing: false,
      downloadingForm: false,
      fileType: '',
      selectedBank: '',
      userBankCode: '',
      mandateInfo: null,
      showMandateSuccessModal: false,
      isMandateSelected: true,
      todayDate: '',
      nextMonthDate: '',
      firstPaymentDate: '',
      sipDate: '',
      isDateFilled: true,
      isSipDateSelected: false,
      selectedPaymentMethod: '',
    };
  }

  public async mandateInfo() {
    const [mandateInfo] = await Promise.all([api.getMandateInfo('DIRECT')]);
    const { minMandateAmount, mandateTypesSupported } = mandateInfo;
    this.setState({
      mandateAmount: getAmountSelectData(minMandateAmount)[0].value,
      currentSelectedMandateFormat:
        mandateTypesSupported.indexOf(PAPER_NACH) !== -1
          ? PAPER_NACH
          : EMANDATE,
      mandateInfo,
    });
  }

  public scheduleOrder = (mandateId: string) => {
    const { url, investmentType, dismiss } = this.props;
    const { firstPaymentDate, isMandateSelected, sipDate } = this.state;
    const nextDate = getNextMonthDate(firstPaymentDate);
    // +1 for month as it starts from 0
    const nextSipDate = `${nextDate.getFullYear()}-${
      nextDate.getMonth() + 1
    }-${sipDate}`;
    const userInfoData = getUserInfoSessionData();

    if (url && url.query) {
      const investmentOwnerCode = url.query.investmentOwnerCode;
      const schedulePaymentData = {
        email: userInfoData.email || '',
        firstInstallmentDate: firstPaymentDate,
        sipDate: investmentType === 'SIP_MF' ? nextSipDate : firstPaymentDate,
        orderType: MAP_INVESTMENTTYPE_TO_ORDERITEMTYPE[investmentType],
        paymentProvider: isMandateSelected
          ? PAYMENT_PROVIDER['mandate']
          : PAYMENT_PROVIDER['link'],
        mandate: mandateId,
        orderOwnerCode: investmentOwnerCode,
      };
      api
        .schedulePayment(schedulePaymentData)
        .then((res) => {
          if (res.httpStatus === 200) {
            this.setState({
              showMandateSuccessModal: true,
            });
          }
        })
        .catch(() => dismiss());
    }
  };

  public async componentDidMount() {
    const { query } = this.props.url;
    const { paymentMode } = query;
    await this.mandateInfo();
    addScriptDynamically('https://checkout.razorpay.com/v1/checkout.js');
    let selectedPaymentMethod;
    api.getUserDetails().then((res) => {
      const { userBankDetails } = res.response.entity;
      const selectedBank = userBankDetails.bankCode || 'UTI';
      const userBankCode = userBankDetails.bankCode || 'UTI';
      const doSelectedBankSupportNetbanking =
        MAP_BANK_TO_PAYMENT[selectedBank] &&
        MAP_BANK_TO_PAYMENT[selectedBank].netBanking;
      const doSelectedBankSupportDebit =
        MAP_BANK_TO_PAYMENT[selectedBank] &&
        MAP_BANK_TO_PAYMENT[selectedBank].debitCard;
      if (doSelectedBankSupportNetbanking) {
        selectedPaymentMethod = 'netbanking';
      } else if (doSelectedBankSupportDebit) {
        selectedPaymentMethod = 'debit_card';
      } else {
        selectedPaymentMethod = 'paper';
      }
      let selectedMethod;
      if (selectedPaymentMethod !== 'paper') {
        selectedMethod = selectedPaymentMethod;
      }
      this.setState({
        userBankDetails,
        selectedBank,
        userBankCode,
        selectedPaymentMethod,
        selectedMethod,
      });
    });

    this.handleDate(selectedPaymentMethod);

    this.setState({
      isMandateSelected: paymentMode === 'mandate',
    });
  }

  private handleRazorpay(data: any, mandateId: string) {
    const options = {
      handler: async (response) => {
        if (response.razorpay_payment_id !== 'undefined') {
          await api.processRazorpayMandate(
            response.razorpay_payment_id,
            'DIRECT'
          );
          this.scheduleOrder(mandateId);
        } else {
          showError('Something went wrong. Please reload and try again.');
        }
      },
      modal: {
        ondismiss: () => {
          this.setState({
            authorizing: false,
          });
        },
      },
    };

    Object.keys(data).forEach((item) => {
      const newKey = item.replace('data-', '');
      dotProp.set(options, newKey, data[item]);
    });

    const rzp1 = new Razorpay(options);
    rzp1.open();
  }

  public handleMandateAuthorize = () => {
    const { imageData, mandateAmount, selectedMethod } = this.state;
    const currentSelectedMandateFormat =
      selectedMethod === 'paper' ? PAPER_NACH : EMANDATE;
    trackAction('submit-mandate', 'mandate-flow', currentSelectedMandateFormat);
    const payload: any = {
      maxAmount: mandateAmount,
      frequencyType: 'MONTHLY',
      file: null,
    };
    if (currentSelectedMandateFormat === PAPER_NACH) {
      payload.file = imageData;
    } else {
      payload.mandateMethod = selectedMethod;
    }
    this.setState({
      authorizing: true,
    });
    api
      .createMandate(
        payload,
        MANDATE_TYPE_URL_MAP[currentSelectedMandateFormat]
      )
      .then((res) => {
        if (currentSelectedMandateFormat === EMANDATE) {
          this.handleRazorpay(
            res.razorpayCheckoutDTO.checkoutParams,
            res.externalId
          );
        } else {
          this.scheduleOrder(res.externalId);
        }
      })
      .catch(() => {
        showError('There was some problem please try again.');
        this.setState({
          authorizing: false,
        });
      });
  };

  private uploadButtonClick = () => {
    document.getElementById('hidden-upload-input').click();
    trackAction('upload-button-click', 'mandate-flow');
  };

  private handleBack = () => {
    trackAction('back-button-click', 'mandate-flow');
    this.setState({
      imageData: null,
      filename: '',
    });
    const img = document.getElementById('uploaded-form');
    img.src = null;
    img.style.display = 'none';
    document.getElementById('hidden-upload-input').value = '';
  };

  private handleUpload = (event: any) => {
    this.setState({
      uploadingFile: true,
    });
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      (e) => {
        const type = file.type;
        const img = document.getElementById('uploaded-form');
        if (type !== 'application/pdf') {
          img.src = e.target.result;
          img.style.display = 'block';
        } else {
          img.style.display = 'none';
          img.src = null;
        }

        this.setState({
          filename: file.name,
          imageData: file,
          uploadingFile: false,
          fileType: type,
        });

        trackAction('file-upload', 'mandate-flow');
      },
      false
    );
    reader.readAsDataURL(file);
  };

  private handleBankSelection = (e: any) => {
    const { value } = e.target;
    let selectedPaymentMethod;
    const doSelectedBankSupportNetbanking =
      MAP_BANK_TO_PAYMENT[value] && MAP_BANK_TO_PAYMENT[value].netBanking;
    const doSelectedBankSupportDebit =
      MAP_BANK_TO_PAYMENT[value] && MAP_BANK_TO_PAYMENT[value].debitCard;
    if (doSelectedBankSupportNetbanking) {
      selectedPaymentMethod = 'netbanking';
    } else if (doSelectedBankSupportDebit) {
      selectedPaymentMethod = 'debit_card';
    } else {
      selectedPaymentMethod = 'paper';
    }
    let selectedMethod;
    if (selectedPaymentMethod !== 'paper') {
      selectedMethod = selectedPaymentMethod;
    }
    this.setState({
      selectedBank: value,
      selectedMethod,
      selectedPaymentMethod,
    });
  };

  private onBackClick = () => {
    this.setState({
      selectedMethod: '',
    });
  };

  public downloadForm = () => {
    const { mandateAmount } = this.state;
    this.setState({
      downloadingForm: true,
    });
    trackAction('download-form-click', 'mandate-flow');
    api
      .downloadPrefilledNachForm(mandateAmount)
      .then((res) => {
        if (res.ok) {
          return res.blob();
        } else if (res.status === 401) {
          const path = `/save/login?refer=${encodeURIComponent(
            '/save/mandate'
          )}`;
          trackAction('download-form-auth-failed', 'mandate-flow');
          Router.pushRoute(path, path);
          return;
        }
      })
      .then((blob) => {
        if (blob) {
          api.handleDownloadFileResponse(blob, 'NachForm.pdf');
          this.setState({
            downloadingForm: false,
          });
          trackAction('download-form-done', 'mandate-flow');
        }
      });
  };

  private renderPaymentRow = (
    option: string,
    approvalTime: string,
    cost: string,
    method: string,
    selected: boolean
  ) => {
    const { selectedPaymentMethod } = this.state;
    return (
      <Fragment>
        <div
          className={cx(
            mandateStyles['row-schedule'],
            styles['row-height'],
            'text--normal',
            { ['border-blue']: method === selectedPaymentMethod },
            method === selectedPaymentMethod ? 'bg-blue' : null
          )}
          onClick={() => this.changeMandateMethod(method)}
        >
          <div className={cx(mandateStyles['cols'])}>{option}</div>
          <div className={cx(mandateStyles['cols'])}>
            <span
              className={cx({ ['recommend-save']: selected }, 'text--medium')}
            >
              {selected ? 'Recommended' : null}
            </span>
          </div>
          <div className={cx(mandateStyles['cols'], 'right bold')}>
            {cost}
            <span className="ml10">|</span>
          </div>
          <div className={cx(mandateStyles['cols'])}>{approvalTime}</div>
        </div>

        <div
          className={cx(
            mandateStyles['approval-method-schedule'],
            { ['border-blue']: method === selectedPaymentMethod },
            method === selectedPaymentMethod ? 'bg-blue' : null,
            'mb20'
          )}
          onClick={() => this.changeMandateMethod(method)}
        >
          <div className={cx(mandateStyles['method'], 'mb10')}>
            <div className="text--xlg">{option}</div>
            {selected ? (
              <div
                className={cx(
                  mandateStyles['recommend'],
                  'font--blue text--lg'
                )}
              >
                Recommended
              </div>
            ) : null}
          </div>
          <div className={mandateStyles['details']}>
            <div className={mandateStyles['left']}>
              <div
                className={cx(
                  mandateStyles['detail-row'],
                  'font--fadedgrey text--sm'
                )}
              >
                <div>Bank Charges</div>
                <div>Bank approval time</div>
              </div>
              <div className={mandateStyles['detail-row']}>
                <div>{cost}</div>
                <div>{approvalTime}</div>
              </div>
            </div>
            <div className={mandateStyles['right']}>
              <button
                className={cx(
                  styles['disable-hover-active-btn'],
                  `${
                    method === selectedPaymentMethod
                      ? 'btn-blue-solid'
                      : 'btn-white'
                  }`,
                  'btn-full btn-small'
                )}
              >
                {method === selectedPaymentMethod ? 'SELECTED' : 'SELECT'}
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  private handleBtnClick = () => {
    const {
      isMandateSelected,
      firstPaymentDate,
      selectedMethod,
      selectedPaymentMethod,
      sipDate,
    } = this.state;
    const { investmentType } = this.props;
    const currentSelectedMandateFormat =
      selectedPaymentMethod === 'paper' ? PAPER_NACH : EMANDATE;
    if (investmentType === 'SIP_MF') {
      if (!sipDate) {
        this.setState({
          isSipDateSelected: true,
        });
        return;
      }
    } else {
      if (!firstPaymentDate) {
        this.setState({
          isDateFilled: false,
        });
        return;
      }
    }
    if (isMandateSelected) {
      if (currentSelectedMandateFormat === PAPER_NACH) {
        this.setState({
          selectedMethod: 'paper',
        });
      } else if (
        selectedMethod === 'debit_card' ||
        selectedMethod === 'netbanking'
      ) {
        trackAction(
          'click',
          'schedule-payment-flow',
          'proceed-to-setup-mandate-click'
        );
        this.handleMandateAuthorize();
      }
    } else {
      trackAction(
        'click',
        'schedule-payment-flow',
        'proceed-with-payment-link-click'
      );
      this.scheduleOrder(null);
    }
  };

  private handleDate = (selectedPaymentMethod: string) => {
    const { paymentMode } = this.props.url.query;

    const dateObj = new Date();

    if (paymentMode === 'mandate') {
      switch (selectedPaymentMethod) {
        case 'netbanking':
          dateObj.setDate(dateObj.getDate() + 3);
          break;
        case 'paper':
          dateObj.setDate(dateObj.getDate() + 15);
          break;
        default:
          break;
      }
    }

    const todayDate = `${dateObj.getFullYear()}-${
      dateObj.getMonth() + 1
    }-${dateObj.getDate()}`;

    const nextMonthDate = `${
      date.getMonth() === 11 ? date.getFullYear() + 1 : date.getFullYear()
    }-${date.getMonth() === 11 ? 1 : date.getMonth() + 2}-${date.getDate()}`;
    this.setState({
      todayDate,
      nextMonthDate,
    });
    return {
      todayDate,
      nextMonthDate,
    };
  };

  private handleCalander = (e: any) => {
    trackAction('select-first-payment-date', 'schedule-payment-flow');
    const customDate = new Date(e);
    const firstPaymentDate = `${customDate.getFullYear()}-${
      customDate.getMonth() + 1
    }-${customDate.getDate()}`;
    this.setState({
      firstPaymentDate,
      isDateFilled: true,
    });
  };

  private getFirstPaymentDate = (
    sipDate: number,
    todayDate: string,
    nextMonthDate: string
  ) => {
    const selectedSipDate = `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${sipDate}`;

    let firstPaymentDate;
    if (
      new Date(selectedSipDate).getTime() > new Date(todayDate).getTime() &&
      new Date(selectedSipDate).getTime() < new Date(nextMonthDate).getTime()
    ) {
      firstPaymentDate = selectedSipDate;
    } else {
      firstPaymentDate = `${
        date.getMonth() + 1 === 12 ? date.getFullYear() + 1 : date.getFullYear()
      }-${date.getMonth() + 1 === 12 ? 1 : date.getMonth() + 1}-${sipDate}`;
    }

    return firstPaymentDate;
  };

  private handleSipDate = (e: any) => {
    const { todayDate, nextMonthDate } = this.state;
    const { value } = e.target;
    const firstPaymentDate = this.getFirstPaymentDate(
      value,
      todayDate,
      nextMonthDate
    );
    this.setState(
      {
        sipDate: value,
        firstPaymentDate,
        isSipDateSelected: false,
      },
      this.editSipDate
    );
  };

  private editSipDate = async () => {
    const { sipDate } = this.state;

    trackAction('select-sip-date', 'schedule-payment-flow');

    const apiResponse = await api.editSipDate(sipDate);
    const { success } = apiResponse || {};
    if (!success) {
      showError(ERROR_MESSAGES.generic);
    }
  };

  private getSipMonthAndYear = () => {
    const { firstPaymentDate } = this.state;
    const firstSipMonth = parseInt(firstPaymentDate.slice(5, 7), 10);
    const sipStartYear = parseInt(firstPaymentDate.slice(0, 4), 10);

    return {
      firstSipMonth,
      sipStartYear,
    };
  };

  private goBack = () => {
    const {
      query: { id, ...queryObj },
    } = this.props.url;
    queryObj.schedulePayment = 'methodSelect';
    Router.pushRoute(`${location.pathname}?${stringify(queryObj)}`);
  };

  private renderDateSelector = () => {
    const { investmentType } = this.props;
    const {
      isMandateSelected,
      todayDate,
      nextMonthDate,
      isDateFilled,
      sipDate,
      firstPaymentDate,
      isSipDateSelected,
    } = this.state;
    return (
      <Fragment>
        {investmentType === 'SIP_MF' ? (
          <Fragment>
            <div className="row mb20">
              <div className="columns small-12 mb15 text--lg font--grey">
                Your subsequent SIP payments will be made on
              </div>
              <div className="columns medium-4">
                <select
                  name="sip"
                  className={cx(styles['select-dd'])}
                  onChange={this.handleSipDate}
                  value={sipDate}
                >
                  <option key={'default'} value="" hidden>
                    Select an SIP date
                  </option>
                  <option value={'5'}>5th of every month</option>
                  <option value={'10'}>10th of every month</option>
                  <option value={'20'}>20th of every month</option>
                </select>
                {isSipDateSelected ? (
                  <div className="font--red text--sm mt5">
                    Please select SIP date to proceed
                  </div>
                ) : null}
              </div>
              <div
                className={cx(
                  styles['pr60'],
                  'columns medium-8 text--normal font--grey'
                )}
              >
                {sipDate ? (
                  <div>
                    Your subsequent SIP Payments will begin from {sipDate}{' '}
                    {MONTH_TEXT_MAP[this.getSipMonthAndYear().firstSipMonth]},{' '}
                    {this.getSipMonthAndYear().sipStartYear}
                  </div>
                ) : null}
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="row mb20">
              <div className="columns small-12 mb15 text--lg">
                When do you want to Schedule your one-time payment?
              </div>
              <div className="columns small-12 mb60">
                <DateSelector
                  selected={firstPaymentDate}
                  onChange={this.handleCalander}
                  minDate={todayDate}
                  maxDate={nextMonthDate}
                />
                {isDateFilled ? null : (
                  <div className="font--red text--sm">
                    Please select an available date
                  </div>
                )}
              </div>
            </div>
          </Fragment>
        )}
        <div className="center mb20">
          <button
            className="btn-small btn-green-solid pl30 pr30 text--normal"
            onClick={this.handleBtnClick}
          >
            {isMandateSelected
              ? 'PROCEED TO SET UP MANDATE'
              : 'PROCEED WITH PAYMENT LINKS'}
          </button>
        </div>
      </Fragment>
    );
  };

  private changeMandateMethod = (method: string) => {
    trackAction('mandate-type-change', 'mandate-flow', method);
    const { sipDate } = this.state;
    const { investmentType } = this.props;
    if (method !== 'paper') {
      this.setState({
        selectedMethod: method,
      });
    }
    const dateData = this.handleDate(method);
    const firstPaymentDate = this.getFirstPaymentDate(
      Number(sipDate),
      dateData.todayDate,
      dateData.nextMonthDate
    );

    this.setState({
      selectedPaymentMethod: method,
      currentSelectedMandateFormat: method === 'paper' ? PAPER_NACH : EMANDATE,
      filename: '',
      firstPaymentDate: investmentType === 'SIP_MF' ? firstPaymentDate : '',
    });
  };

  public render() {
    const { dismiss, investmentType, url, amount } = this.props;
    const {
      selectedMethod,
      downloadingForm,
      uploadingFile,
      authorizing,
      filename,
      fileType,
      selectedBank,
      userBankCode,
      userBankDetails,
      mandateInfo,
      showMandateSuccessModal,
      isMandateSelected,
      sipDate,
      firstPaymentDate,
    } = this.state;
    const doSelectedBankSupportNetbanking =
      MAP_BANK_TO_PAYMENT[selectedBank] &&
      MAP_BANK_TO_PAYMENT[selectedBank].netBanking;
    const doSelectedBankSupportDebit =
      MAP_BANK_TO_PAYMENT[selectedBank] &&
      MAP_BANK_TO_PAYMENT[selectedBank].debitCard;
    return (
      <Fragment>
        {!mandateInfo ? null : (
          <div className={cx({ ['hide']: showMandateSuccessModal })}>
            <Modal
              fullScreen
              showClose
              title={
                isMandateSelected
                  ? 'Schedule your SIP payment'
                  : 'Schedule your payment link'
              }
              maxWidth={'650px'}
              onDismiss={dismiss}
            >
              <div className={cx(styles['back'])} onClick={this.goBack}>
                &#8592;
              </div>
              <div className={cx(mandateStyles['mandate-options'])}>
                {!filename && isMandateSelected ? (
                  <Fragment>
                    <div className="font--grey text--lg pl15">
                      Select your bank
                    </div>
                    <div className="row m0 border-bottom">
                      <div
                        className={cx(
                          mandateStyles.selector,
                          'columns medium-4'
                        )}
                      >
                        <span className={mandateStyles.ticker}>
                          <select
                            name="bank-select"
                            value={selectedBank}
                            onChange={this.handleBankSelection}
                          >
                            {BANK_LIST.map((bank: any) =>
                              MAP_BANK_TO_PAYMENT[bank.value].netBanking ||
                              MAP_BANK_TO_PAYMENT[bank.value].debitCard ||
                              bank.value === userBankCode ? (
                                <option key={bank.value} value={bank.value}>
                                  {bank.label}
                                </option>
                              ) : null
                            )}
                          </select>
                        </span>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {selectedMethod !== 'paper' ? (
                  <Fragment>
                    <div>
                      {isMandateSelected ? (
                        <div
                          className={cx(
                            mandateStyles['payment-method-container'],
                            'pl15 pr15'
                          )}
                        >
                          {MAP_BANK_TO_PAYMENT[selectedBank] && (
                            <Fragment>
                              <div className="mb10 mt20 text-lg font--grey">
                                Select an approval method
                              </div>
                            </Fragment>
                          )}
                          {MAP_BANK_TO_PAYMENT[selectedBank] &&
                          MAP_BANK_TO_PAYMENT[selectedBank].netBanking
                            ? this.renderPaymentRow(
                                'Netbanking',
                                '1-3 business days',
                                'Free',
                                'netbanking',
                                doSelectedBankSupportNetbanking
                              )
                            : null}
                          {MAP_BANK_TO_PAYMENT[selectedBank] &&
                          MAP_BANK_TO_PAYMENT[selectedBank].debitCard
                            ? this.renderPaymentRow(
                                'Debit Card',
                                'Instant Approval',
                                'Free',
                                'debit_card',
                                !doSelectedBankSupportNetbanking &&
                                  doSelectedBankSupportDebit
                              )
                            : null}
                          {/* {MAP_BANK_TO_PAYMENT[selectedBank] &&
                          MAP_BANK_TO_PAYMENT[selectedBank].paper &&
                          selectedBank === userBankCode
                            ? this.renderPaymentRow(
                                'Mandate Form',
                                '10-14 business days',
                                '₹250',
                                'paper',
                                !doSelectedBankSupportNetbanking &&
                                  !doSelectedBankSupportDebit
                              )
                            : null} */}
                        </div>
                      ) : null}
                    </div>

                    {this.renderDateSelector()}
                  </Fragment>
                ) : null}

                {selectedMethod === 'paper' && userBankDetails ? (
                  <Fragment>
                    <Nach
                      userBankDetails={userBankDetails}
                      downloadForm={this.downloadForm}
                      downloadingForm={downloadingForm}
                      handleUpload={this.handleUpload}
                      uploadButtonClick={this.uploadButtonClick}
                      uploadingFile={uploadingFile}
                      authorizing={authorizing}
                      fileName={filename}
                      handleBack={this.handleBack}
                      handleMandateAuthorize={this.handleMandateAuthorize}
                      fileType={fileType}
                    >
                      <div className="row ml0 mr0">
                        <div className="columns large-11  small-10">
                          <h5 className="mb20 mt10">
                            Please follow below instructions to complete your
                            mandate{' '}
                          </h5>
                        </div>
                        {/* Just placeholder */}
                        <div className="columns large-1 small-2 text-right pl0">
                          <span
                            onClick={() => dismiss()}
                            className={cx(
                              'sm-close',
                              mandateStyles.close,
                              'plr'
                            )}
                          >
                            {/* &#10005; */}
                          </span>
                        </div>
                      </div>
                    </Nach>
                    {!filename ? (
                      <div>
                        <button
                          onClick={this.onBackClick}
                          className="btn btn-blue btn-small ml15 mt20"
                        >
                          BACK
                        </button>
                      </div>
                    ) : null}
                  </Fragment>
                ) : null}
                <div />
              </div>
            </Modal>
          </div>
        )}

        {showMandateSuccessModal ? (
          isMandateSelected ? (
            <MandateSuccessScheduleModal
              investmentType={investmentType}
              url={url}
              amount={amount}
              sipDate={sipDate}
              firstPaymentDate={firstPaymentDate}
            />
          ) : (
            <PaymentLinkScheduleModal
              amount={amount}
              investmentType={investmentType}
              sipDate={sipDate}
              firstPaymentDate={firstPaymentDate}
            />
          )
        ) : null}
      </Fragment>
    );
  }
}

export default ScheduleMandate;



// WEBPACK FOOTER //
// ./components/paymentSchedule/scheduleMandate.tsx